import { render, staticRenderFns } from "./QrCodeRichMenuDialog.vue?vue&type=template&id=5c0ac029&scoped=true&lang=html&"
import script from "./QrCodeRichMenuDialog.vue?vue&type=script&lang=js&"
export * from "./QrCodeRichMenuDialog.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeRichMenuDialog.vue?vue&type=style&index=0&id=5c0ac029&prod&media=screen&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ac029",
  null
  
)

export default component.exports